export default "__VITE_ASSET__AOAZR3kh__"